module.exports = __webpack_public_path__ + "static/media/emer.6dd5a63d.jpg";